import vector from "../assets/vector.png";
import up from "../assets/up.png";


export default function Hero() {
  return (
    <section id="home" className="bg-gradient-to-b from-green-50 to-white">
      <div className="max-w-6xl mx-auto px-6 py-28 text-center">

        {/* Heading */}
        <h1 className="text-5xl md:text-7xl font-bold leading-[1.15] text-gray-900">
          <span className="relative inline-block">
            {/* Vector intersecting the "I" */}
            <img
              src={vector}
              alt="icon"
              className="absolute left-[-60px] top-[-4px] h-[80px]"
            />
            Investing
          </span>{" "}
          in the{" "}
          <span className="text-primary">Future</span> of
          <br />
          Capital Markets
        </h1>

        {/* Subtext */}
        <p className="mt-6 text-gray-600 max-w-3xl mx-auto">
          We partner with visionary founders and institutions to drive long-term
          value through transparency, innovation, and disciplined capital
          allocation.
        </p>

        {/* CTA Buttons */}
        {/* CTA Buttons */}
<div className="mt-10 flex justify-center gap-4">

  {/* Explore Our Ventures */}
  <a
    href="#ventures"
    className="
      bg-primary text-white px-7 py-3 rounded-full text-sm font-medium
      transition-all duration-300 ease-out
      hover:bg-green-600 hover:-translate-y-[2px]
      active:translate-y-0
    "
  >
    Explore Our Ventures →
  </a>

  {/* Partner With Us */}
  <a
    href="#contact"
    className="
      border border-primary text-primary px-7 py-3 rounded-full text-sm font-medium
      transition-all duration-300 ease-out
      hover:bg-primary hover:text-white hover:-translate-y-[2px]
      active:translate-y-0
    "
  >
    Partner With Us
  </a>

</div>



        <div className="mt-10 flex justify-center">
<div className="flex items-center gap-3 px-4 py-2 border border-green-300 rounded-full shadow-sm">
    
    {/* Icon */}
    <img
      src={up}
      alt="growth icon"
      className="h-5 w-5"
    />

    {/* Text */}
    <p className="text-sm font-medium tracking-wide text-primary">
      Building the future of capital market ecosystem
    </p>

  </div>
</div>



      </div>
    </section>
  );
}
